'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _jqueryBridget = require('jquery-bridget');

var _jqueryBridget2 = _interopRequireDefault(_jqueryBridget);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

require('flickity-imagesloaded');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Make Flickity a jQuery Plugin
_flickity2.default.setJQuery(_jquery2.default);

// Vendor

(0, _jqueryBridget2.default)('flickity', _flickity2.default, _jquery2.default);

//Check if enough slides to have wraparound
var checkWrap = function checkWrap(carousel, cells) {
  if (carousel && cells) {
    var cellsTotalWidth = 0;
    cells.each(function () {
      var cell = (0, _jquery2.default)(this);
      cellsTotalWidth += parseInt(cell.css('width')) + parseInt(cell.css('margin-right')) + parseInt(cell.css('margin-left'));
    });
    var carouselWidth = parseFloat(carousel.css('width'));
    return cellsTotalWidth > carouselWidth;
  }

  return false;
};

/**************
 *
 * Sliders
 *
 **************/

var homeHeroSlider = function homeHeroSlider() {
  var $heroSlider = (0, _jquery2.default)(_dom2.default.heroSlider);

  $heroSlider.flickity({
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 5000
  });
};

var collectionSlider = function collectionSlider() {
  var $collectionSlider = (0, _jquery2.default)(_dom2.default.collectionSlider);

  var desktopOptions = {
    prevNextButtons: true,
    pageDots: false,
    imagesLoaded: true,
    wrapAround: true,
    contain: true
  };

  var mobileOptions = {
    prevNextButtons: true,
    pageDots: false,
    freeScroll: true,
    cellAlign: 'left',
    imagesLoaded: true,
    wrapAround: true
  };

  var collectionSliderMobileActive = false;
  var collectionSliderDesktopActive = false;

  var flickityInit = function flickityInit(options, mobileState, desktopState) {
    $collectionSlider.each(function () {
      var $currentSlider = (0, _jquery2.default)(this);
      var $currentSliderSlides = $currentSlider.find(_dom2.default.collectionSlide);

      options.wrapAround = checkWrap($currentSlider, $currentSliderSlides);
      $currentSlider.flickity(options);
    });

    collectionSliderMobileActive = mobileState;
    collectionSliderDesktopActive = desktopState;
  };

  if ((0, _jquery2.default)(window).width() < 768) {
    flickityInit(mobileOptions, true, false);
  } else {
    flickityInit(desktopOptions, false, true);
  }

  (0, _jquery2.default)(window).on('resize', function () {
    if ((0, _jquery2.default)(window).width() < 768) {
      if (!collectionSliderMobileActive) {
        //Reinit flickity
        $collectionSlider.flickity('destroy');
        flickityInit(mobileOptions, true, false);
      }
    } else {
      if (!collectionSliderDesktopActive) {
        //Reinit flickity
        $collectionSlider.flickity('destroy');
        flickityInit(desktopOptions, false, true);
      }
    }
  });
};

var featureFilterSlider = function featureFilterSlider() {
  var $featureFilterSlider = (0, _jquery2.default)(_dom2.default.featureFilterSlider);

  $featureFilterSlider.each(function () {
    var $current = (0, _jquery2.default)(this);

    $current.flickity({
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      autoPlay: 5000,
      imagesLoaded: true
    });
  });
};

var originalPosterSlider = function originalPosterSlider() {
  var $originalPosterSlider = (0, _jquery2.default)(_dom2.default.originalPosterSlider);

  var options = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true,
    imagesLoaded: true
  };

  var flickityInit = function flickityInit(options, mobileState, desktopState) {
    $originalPosterSlider.flickity(options);

    flickityMobileActive = mobileState;
    flickityDesktopActive = desktopState;
  };

  var flickityMobileActive = false;
  var flickityDesktopActive = false;

  if ((0, _jquery2.default)(window).width() < 1024) {
    flickityInit(options, true, false);
  } else {
    flickityDesktopActive = true;
  }

  (0, _jquery2.default)(window).on('resize', function () {
    if ((0, _jquery2.default)(window).width() < 1024) {
      if (!flickityMobileActive) {
        //Reinit flickity
        flickityInit(options, true, false);
      }
    } else {
      if (!flickityDesktopActive) {
        $originalPosterSlider.flickity('destroy');
        flickityDesktopActive = true;
        flickityMobileActive = false;
      }
    }
  });
};

var instagramSlider = function instagramSlider() {
  var $instagramSlider = (0, _jquery2.default)(_dom2.default.instagramSlider);

  var options = {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    imagesLoaded: true
  };

  var flickityInit = function flickityInit(options, mobileState, desktopState) {
    $instagramSlider.flickity(options);

    flickityMobileActive = mobileState;
    flickityDesktopActive = desktopState;
  };

  var flickityMobileActive = false;
  var flickityDesktopActive = false;

  if ((0, _jquery2.default)(window).width() < 1024) {
    flickityInit(options, true, false);
  } else {
    flickityDesktopActive = true;
  }

  (0, _jquery2.default)(window).on('resize', function () {
    if ((0, _jquery2.default)(window).width() < 1024) {
      if (!flickityMobileActive) {
        //Reinit flickity
        flickityInit(options, true, false);
      }
    } else {
      if (!flickityDesktopActive) {
        $instagramSlider.flickity('destroy');
        flickityDesktopActive = true;
        flickityMobileActive = false;
      }
    }
  });
};

var rewardsSlider = function rewardsSlider() {
  (0, _jquery2.default)(_dom2.default.rewardsDetails).flickity({
    prevNextButtons: false,
    contain: true,
    pageDots: false
  });
};

//Init
var init = exports.init = function init() {
  homeHeroSlider();
  collectionSlider();
  featureFilterSlider();
  originalPosterSlider();
  instagramSlider();
  rewardsSlider();
};